/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import {convertToItems} from '../../common/utilities';
import InputList from '../../containers/disponent/input-list.js';
import Button from '../../components/task/shop/form/button';
import {getDepartments} from "../../store/dispo/selectors";
import {getTasksCurrent} from "../../store/tasks/selectors";
import * as R from 'ramda';

const WrapperWrapper = styled.div`
	background: #fff;
	padding: 13px 19px;
	border-radius: 8px;
	border: 1px solid #d9d7d7;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
`;

const DepartmentsInput = ({
                        data,
                        handleSelect,
                              departments,
                        handleComplete,
                        currentTask,
                    }) => {
    const pluckStepNumber = (val) => val.id;//val.replace(/(\d).*/, '$1');
    const pluckStepValue = (val) => {return {value: val.id, viewValue: val.name}};//val.replace(/(\d).*/, '$1');
    return (
        <WrapperWrapper>
            <InputList
                items={convertToItems(
                    departments,
                    data.value,
                    (item, val) => {
                        // console.log("ConvertItem", item, val, R.indexOf(item.id, val) >= 0);
                        return R.indexOf(item.id, val) >= 0;
                    }
                )}
                handleClick={(val) => handleSelect(val)}
                currentTask={currentTask}
                isDepartment={true}
            />

            <Button handleClick={() => handleComplete(data)} width="100%"/>
        </WrapperWrapper>
    );
};

export default connect(
    (state) => ({
        departments: getDepartments(state),
        currentTask: getTasksCurrent(state),
    })
)(DepartmentsInput);



// WEBPACK FOOTER //
// ./src/containers/disponent/departments-input.js